<template>
    <div class="subscribe_fields text-align-center margin-vertical-10">
        <div v-if="$store.state.optional_data[this_page].form.accepted != undefined">
            <h3 class="font-size-24 margin-vertical-15 col-mobile-100 col-tablet-80 center-block">{{$store.state.optional_data[this_page].form.title}}</h3>
        </div>
        <div class="margin-vertical-15" v-else>
            <h3 class="font-size-24 col-mobile-100 col-tablet-70 center-block">If you want to receive information about future promotions, please check in.</h3>
            <form id="subscribe--form" @submit.prevent="send_form()" novalidate>
                <div class="clearfix margin-vertical-20" v-if="local_config.fields.phone != undefined && local_config.fields.phone.is_on == true">
                    <phone></phone>
                    <sms_optin></sms_optin>
                </div>

                <div class="clearfix margin-vertical-20" v-if="local_config.fields.email_optin != undefined && local_config.fields.email_optin.is_on == true">
                    <email></email>
                    <email_optin></email_optin>
                </div>
                <button class="submit-button" type="submit">SUBMIT</button>
            </form>
        </div>
    </div>
</template>

<script>
    import {fields, form_methods, requests_methods, validation} from "../mixins/requests";

    import email from '../components/fields/email'
    import phone from '../components/fields/phone'
    import email_optin from '../components/fields/email_optin'
    import sms_optin from '../components/fields/sms_optin'

    export default {
        name: "subscribe_form",
        mixins: [fields,form_methods, requests_methods, validation],
        components: {
            email,
            phone,
            email_optin,
            sms_optin,
        },
        computed: {
             this_page(){
                return this.$store.state.active_view
            }
        },
    }
</script>

<style scoped>

</style>